import React from 'react';
import { Button } from '@gik/ui';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';
import Form, { FormField, FormSchemaEntry } from '@gik/ui/Form';
import { openNonD2CUrl, alertNoNonD2CUrlAvailable } from '@gik/checkout/utils/productUtils';
import { emailRecipientInfo } from '@gik/checkout/api';
import { Product } from '@gik/core/models/gik/Product';
import { InterstitialEmailFormValues } from './ExternalProductInterstitial';

interface ISendEmailPageProps {
  products?: Product[];
  inkindRouteId?: string;
}

export default function SendEmailPage({ products, inkindRouteId }: ISendEmailPageProps): React.ReactElement {
  const { t } = useTranslation();

  async function handleSubmit(values: InterstitialEmailFormValues) {
    try {
      await emailRecipientInfo(products[0].id, {
        userEmail: values.email,
        subscribeToNewsletter: values.subscribeToNewsletter,
        inkindRouteId,
      });
    } catch (err) {
      // TODO: gracefully handle backend error ?
      console.error(err);
    }

    const productNonD2CUrl = products && products.length ? products[0].productNonD2CUrl : null;
    if (productNonD2CUrl) {
      openNonD2CUrl(productNonD2CUrl);
    } else {
      alertNoNonD2CUrlAvailable();
    }
  }

  const schema: FormSchemaEntry[] = [
    { name: 'email', type: 'email', required: true, props: { placeholder: 'Email' } },
    {
      name: 'subscribeToNewsletter',
      type: 'checkbox',
      default: true,
      props: { label: t(translationKeys.emailKeepUpdated), variant: 'white' },
    },
  ];

  return (
    <div className="gik-external-product-interstitial-email">
      <p>{t(translationKeys.emailText)}</p>
      <Form
        onSubmit={handleSubmit}
        schema={schema}
        vertical
        render={({ valid, submitting }) => {
          return (
            <>
              <FormField name="email" />
              <FormField name="subscribeToNewsletter" />
              <Button variant="secondary" type="submit" loading={submitting} disabled={!valid}>
                {t(translationKeys.emailButton)}
              </Button>
            </>
          );
        }}
      />
    </div>
  );
}
